module.exports = __webpack_public_path__ + "img/35352-021.838f8392.jpg";